/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Asterisk, Minus, Plus } from "lucide-react";

export const OperatorSelection = ({
  operator,
  onChange,
}: {
  operator: any;
  onChange: any;
}) => {
  const operatorList: any = {
    "+": <Plus />,
    "-": <Minus />,
    "*": <Asterisk />,
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={"icon"} variant={"ghost"} className=" ml-3" type="button">
          {operatorList[operator]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className=" text-center !max-w-[40px] !w-[40px] !min-w-[40px]"
        align="center"
      >
        {/* <DropdownMenuLabel>Select Operator</DropdownMenuLabel> */}
        {Object.keys(operatorList).map((operator_item) => (
          <DropdownMenuItem
            key={operator_item}
            onClick={() => onChange(operator_item)}
          >
            {operatorList[operator_item]}
          </DropdownMenuItem>
        ))}

        {/* <DropdownMenuGroup>
          <DropdownMenuItem>
            Profile
            <DropdownMenuShortcut>⇧⌘P</DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuItem>
            Billing
            <DropdownMenuShortcut>⌘B</DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuItem>
            Settings
            <DropdownMenuShortcut>⌘S</DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuItem>
            Keyboard shortcuts
            <DropdownMenuShortcut>⌘K</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator /> */}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
